var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image__box"},[(_vm.isImage)?_c('img',{staticClass:"image__cover",attrs:{"src":_vm.url,"alt":_vm.alt},on:{"error":_vm.imageNotFound}}):_c('div',{staticClass:"image__box image__box__overlay"})])}
var staticRenderFns = []

export { render, staticRenderFns }